/* FRAUENSCHUH US - Kopfzeile mit Mega-Feld (fskz). Auszug aus dem EU-Facelift (fs-pdp.js, Teil D). ES5-Stil. */
(function () {
  'use strict';

  function slice(l) { return Array.prototype.slice.call(l); }
  function daten(wurzel, haken) {
    var el = wurzel.querySelector('[' + haken + ']');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var sanft = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- Teil D */
  /* Kopfzeile mit Mega-Feld (fskz) */
  function initKopf(wurzel) {
    if (wurzel.dataset.fskzInit === '1') return;
    wurzel.dataset.fskzInit = '1';

    var cfg = daten(wurzel, 'data-fskz-daten') || {};
    var punkte = slice(wurzel.querySelectorAll('[data-fskz-punkt]'));
    var felder = slice(wurzel.querySelectorAll('[data-fskz-feld]'));
    var bar = wurzel.querySelector('.fskz__bar');
    var offenerIndex = null;
    var weckerAuf = 0, weckerZu = 0;

    function feldFuer(i) {
      for (var k = 0; k < felder.length; k++) {
        if (felder[k].getAttribute('data-fskz-feld') === String(i)) return felder[k];
      }
      return null;
    }
    function zumachen() {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      felder.forEach(function (f) {
        if (!f.classList.contains('is-offen') || f.classList.contains('is-zu')) return;
        if (sanft) { f.classList.remove('is-offen'); return; }
        /* weiches Schliessen: erst ausblenden/einfahren (is-zu), dann ausblenden */
        f.classList.add('is-zu');
        window.clearTimeout(f._zuWecker);
        f._zuWecker = window.setTimeout(function () { f.classList.remove('is-offen'); f.classList.remove('is-zu'); }, 620);
      });
      punkte.forEach(function (p) {
        p.classList.remove('is-offen');
        if (p.getAttribute('aria-haspopup')) p.setAttribute('aria-expanded', 'false');
      });
      wurzel.classList.remove('is-offen');
      offenerIndex = null;
    }
    function aufmachen(i) {
      var feld = feldFuer(i);
      if (!feld) { zumachen(); return; }
      felder.forEach(function (f) { window.clearTimeout(f._zuWecker); f.classList.remove('is-offen'); f.classList.remove('is-zu'); });
      punkte.forEach(function (p) {
        var an = p.getAttribute('data-fskz-punkt') === String(i);
        p.classList.toggle('is-offen', an);
        if (p.getAttribute('aria-haspopup')) p.setAttribute('aria-expanded', an ? 'true' : 'false');
      });
      feld.classList.add('is-offen');
      wurzel.classList.add('is-offen');
      werbebildLaden(i);
      bildBreiten();
      wurzel.classList.remove('is-eingefahren');
      offenerIndex = i;
    }
    function spaeterAuf(i) {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      var wartezeit = offenerIndex === null ? (cfg.aufAuf || 90) : (cfg.aufWechsel || 60);
      weckerAuf = window.setTimeout(function () { aufmachen(i); }, sanft ? 0 : wartezeit);
    }
    function spaeterZu() {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      weckerZu = window.setTimeout(zumachen, sanft ? 0 : (cfg.zu != null ? cfg.zu : 0));
    }

    punkte.forEach(function (p) {
      var i = p.getAttribute('data-fskz-punkt');
      var hatFeld = !!feldFuer(i);
      p.addEventListener('mouseenter', function () {
        if (window.innerWidth <= 900) return;
        if (hatFeld) { werbebildLaden(i); spaeterAuf(i); } else { spaeterZu(); }
      });
      /* Tastatur: der Link bleibt ein Link, Pfeil nach unten oeffnet das Feld */
      p.addEventListener('keydown', function (e) {
        if (!hatFeld) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          werbebildLaden(i);
          aufmachen(i);
          /* Ohne das steht der Fokus weiter in der Leiste und der naechste
             Tabulator schliesst das eben geoeffnete Feld wieder. */
          var feld = feldFuer(i);
          var erster = feld ? feld.querySelector('a') : null;
          if (erster) erster.focus();
        }
        if (e.key === 'Escape') { zumachen(); p.focus(); }
      });
      p.addEventListener('focus', function () {
        if (window.innerWidth <= 900) return;
        if (hatFeld) aufmachen(i); else zumachen();
      });
    });

    felder.forEach(function (f) {
      f.addEventListener('mouseenter', function () {
        window.clearTimeout(weckerZu);
      });
    });
    wurzel.addEventListener('mouseleave', spaeterZu);
    wurzel.addEventListener('focusout', function (e) {
      if (!wurzel.contains(e.relatedTarget)) zumachen();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zumachen();
    });

    /* Breite der Werbebilder: Hoehe des Menues mal Seitenverhaeltnis. So wird
       das Bild ganz gezeigt, beruehrt oben und unten den Rand und bestimmt
       nicht selbst die Hoehe des Menues (23.09.2026). */
    function bildBreiten() {
      slice(wurzel.querySelectorAll('[data-fskz-feld]')).forEach(function (feld) {
        var figur = feld.querySelector('.fskz__werbung');
        var bild = figur ? figur.querySelector('img') : null;
        if (!figur || !bild) return;
        var gruppen = feld.querySelector('.fskz__gruppen');
        if (!gruppen) return;
        var war = feld.classList.contains('is-offen');
        if (!war) { feld.style.visibility = 'hidden'; feld.style.display = 'block'; }
        var hoehe = figur.getBoundingClientRect().height;
        if (!war) { feld.style.display = ''; feld.style.visibility = ''; }
        /* 23.09.2026: Bisher kam das Verhaeltnis aus der GELADENEN Datei. Die
           Werbebilder laden aber erst beim Oeffnen - beim Rechnen war
           naturalWidth 0, es galt der Notwert 0,75 und das Bild bekam Raender.
           Die Attribute width/height stehen von Anfang an im Markup. */
        var aw = parseFloat(bild.getAttribute('width')) || bild.naturalWidth;
        var ah = parseFloat(bild.getAttribute('height')) || bild.naturalHeight;
        var verhaeltnis = (aw && ah) ? aw / ah : 0.75;
        if (hoehe > 0) {
          figur.style.setProperty('--fskz-bildbreite', Math.round(hoehe * verhaeltnis) + 'px');
        }
      });
    }
    bildBreiten();
    window.addEventListener('resize', bildBreiten, { passive: true });
    slice(wurzel.querySelectorAll('.fskz__werbung img')).forEach(function (b) {
      if (!b.complete) b.addEventListener('load', bildBreiten);
    });

    /* Sprachwahl selbst verdrahten: das Theme-JS kennt nur seine eigene
       Kopfzeile, die hier abgeschaltet ist (23.09.2026). */
    slice(wurzel.querySelectorAll('[data-disclosure-toggle]')).forEach(function (knopf) {
      var huelle = knopf.closest('[data-disclosure]');
      var liste = huelle ? huelle.querySelector('[data-disclosure-list], ul, .disclosure-list') : null;
      if (!huelle || !liste) return;
      liste.hidden = true;
      knopf.setAttribute('aria-expanded', 'false');
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var offen = liste.hidden;
        liste.hidden = !offen;
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        huelle.classList.toggle('is-visible', offen);
      });
      document.addEventListener('pointerdown', function (e) {
        if (huelle.contains(e.target)) return;
        liste.hidden = true;
        knopf.setAttribute('aria-expanded', 'false');
        huelle.classList.remove('is-visible');
      });
    });

    /* Werbebilder erst anstupsen, wenn der Punkt das erste Mal ueberfahren wird */
    function werbebildLaden(i) {
      var feld = feldFuer(i);
      if (!feld) return;
      slice(feld.querySelectorAll('[data-fskz-werbebild]')).forEach(function (b) {
        if (b.dataset.fskzGeladen === '1') return;
        b.dataset.fskzGeladen = '1';
        b.setAttribute('decoding', 'async');
        b.addEventListener('load', function () { bildBreiten(); }, { once: true });
        if (b.getAttribute('data-quellen')) b.setAttribute('srcset', b.getAttribute('data-quellen'));
        if (b.getAttribute('data-quelle')) b.setAttribute('src', b.getAttribute('data-quelle'));
      });
    }

    /* Handy-Menue */
    var burger = wurzel.querySelector('[data-fskz-burger]');
    var mobil = wurzel.querySelector('[data-fskz-mobil]');
    /* Hoehe des Handy-Menues: vom unteren Rand der Leiste bis zum Fensterende */
    function mobilHoehe() {
      if (!bar) return;
      var unten = bar.getBoundingClientRect().bottom;
      wurzel.style.setProperty('--fskz-mobilhoehe', Math.max(240, Math.round(window.innerHeight - unten)) + 'px');
    }
    mobilHoehe();
    window.addEventListener('resize', mobilHoehe, { passive: true });
    window.addEventListener('scroll', mobilHoehe, { passive: true });

    if (burger && mobil) {
      burger.addEventListener('click', function () {
        var offen = mobil.classList.toggle('is-offen');
        wurzel.classList.toggle('is-menue', offen);
        mobilHoehe();
        burger.setAttribute('aria-expanded', offen ? 'true' : 'false');
        burger.setAttribute('aria-label', offen ? 'Schließen' : 'Menü');
        document.documentElement.style.overflow = offen ? 'hidden' : '';
      });
      /* Escape schliesst das Handy-Menue */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !mobil.classList.contains('is-offen')) return;
        mobil.classList.remove('is-offen');
        wurzel.classList.remove('is-menue');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Menü');
        document.documentElement.style.overflow = '';
      });
    }

    /* Warenkorb-Zahl frisch halten: das Theme-JS aktualisiert nur Zaehler
       INNERHALB seiner eigenen Kopfzeile (theme.js: [data-js-cart-count] im
       Section-Container). Unsere steht ausserhalb, also selbst nachfragen. */
    var korb = wurzel.querySelector('[data-fskz-korb]');
    if (korb && window.fetch) {
      var korbHolen = function () {
        window.fetch(cfg.korbJs || '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (w) {
            if (!w || typeof w.item_count !== 'number') return;
            korb.textContent = w.item_count;
            if (w.item_count > 0) korb.removeAttribute('hidden');
            else korb.setAttribute('hidden', 'hidden');
          })
          .catch(function () {});
      };
      ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (ev) {
        document.addEventListener(ev, korbHolen);
      });
      window.addEventListener('pageshow', korbHolen);
    }

    /* Einfahren: 2 px abwaerts versteckt, 8 px aufwaerts oder ganz oben zeigt */
    if (cfg.einfahren !== false) {
      var letzte = window.scrollY, wende = window.scrollY, abwaerts = true;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        var jetztAb = y > letzte;
        if (jetztAb !== abwaerts) { abwaerts = jetztAb; wende = y; }
        letzte = y;
        if (offenerIndex !== null) return;
        if (mobil && mobil.classList.contains('is-offen')) return;
        if (y <= 0 || (!abwaerts && wende - y > 8)) {
          wurzel.classList.remove('is-eingefahren');
        } else if (abwaerts && y - wende > 2 && y > (bar ? bar.offsetHeight : 74)) {
          wurzel.classList.add('is-eingefahren');
        }
      }, { passive: true });
    }
  }



  /* Gleitender Strich unter dem Menuepunkt, ueber dem die Maus steht. */
  function initStrich(wurzel) {
    var nav = wurzel.querySelector('.fskz__nav');
    var strich = wurzel.querySelector('[data-fskz-strich]');
    if (!nav || !strich || wurzel.dataset.fskzStrich === '1') return;
    wurzel.dataset.fskzStrich = '1';
    var punkte = slice(nav.querySelectorAll('.fskz__punkt'));
    var weg = null;
    function hin(p) {
      if (weg) { window.clearTimeout(weg); weg = null; }
      var n = nav.getBoundingClientRect();
      var b = p.getBoundingClientRect();
      var z = n.width / (nav.offsetWidth || n.width) || 1;
      var x = (b.left - n.left) / z, w = b.width / z;
      var neu = !strich.classList.contains('is-sichtbar');
      if (neu) strich.classList.add('is-neu');
      strich.style.width = w + 'px';
      strich.style.transform = 'translateX(' + x + 'px)';
      if (neu) { void strich.offsetWidth; strich.classList.add('is-sichtbar'); window.setTimeout(function () { strich.classList.remove('is-neu'); }, 40); }
    }
    function fort() {
      weg = window.setTimeout(function () { strich.classList.remove('is-sichtbar'); }, 0);
    }
    punkte.forEach(function (p) {
      p.addEventListener('mouseenter', function () { hin(p); });
      p.addEventListener('focus', function () { hin(p); });
    });
    wurzel.addEventListener('mouseleave', fort);
    nav.addEventListener('focusout', function (e) { if (!nav.contains(e.relatedTarget)) fort(); });
  }

  function alles(bereich) {
    slice((bereich || document).querySelectorAll('[data-fskz]')).forEach(initKopf);
    slice((bereich || document).querySelectorAll('[data-fskz]')).forEach(initStrich);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(document); });
  } else {
    alles(document);
  }
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
